@let term = store.filters()?.term || "";

<section class="use-work-object-template-mat-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="projectTemplateIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "template.ui.use.dialogheader.label" | translate }}
      </div>
    </span>
  </div>

  <div class="use-work-object-template-mat-dialog-body">
    <form [formGroup]="applyWorkObjectTemplateFromGroup">
      <mat-horizontal-stepper
        [linear]="true"
        (selectedIndexChange)="selectedStep.set($event)"
        #stepper
        class="use-template-stepper"
      >
        <mat-step [stepControl]="applyWorkObjectTemplateFromGroup">
          <ng-template matStepLabel>{{
            "template.ui.use.stepper.1.label" | translate
          }}</ng-template>
          <div
            class="flex--r-fs h-100 gap--8"
            [ngClass]="{ 'active-step': selectedStep() === 0 }"
          >
            <div class="list-view">
              <ng-bee-w-h-search-term-util
                class="m--8"
                [isCharTriggerLimited]="false"
                (onSearchTermInput)="search($event)"
                [initialValue]="term"
              >
              </ng-bee-w-h-search-term-util>
              <div class="table-wrapper">
                @if (store.isLoading()) {
                  <div class="table-loading-overlay">
                    <mat-spinner [diameter]="32"></mat-spinner>
                  </div>
                }
                <mat-table
                  class="side-template-table flex-1"
                  #table
                  [dataSource]="dataSource"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="id">
                    <mat-header-cell
                      class="image-cell"
                      *matHeaderCellDef
                    ></mat-header-cell>
                    <mat-cell class="image-cell" *matCellDef="let row">
                      <i
                        class="workheld-icons"
                        [innerHTML]="projectTemplateIcon"
                      ></i>
                    </mat-cell>
                  </ng-container>

                  <!-- fullName Column -->
                  <ng-container *ngFor="let column of columns">
                    <ng-container
                      *ngIf="column.isModelProperty"
                      [matColumnDef]="column.property"
                    >
                      <mat-header-cell *matHeaderCellDef>
                        {{ column.name | translate }}</mat-header-cell
                      >
                      <mat-cell *matCellDef="let row">
                        <div
                          class="html-overflow"
                          matTooltip="{{ row[column.property] }}"
                        >
                          {{ row[column.property] }}
                        </div>
                      </mat-cell>
                    </ng-container>
                  </ng-container>

                  <mat-row
                    *matRowDef="let row; columns: visibleColumns"
                    (click)="selectWorkObjectTemplate(row)"
                    (keydown.enter)="selectWorkObjectTemplate(row)"
                    [ngClass]="{
                      'selected-template':
                        selectedWorkObjectTemplateDOM &&
                        row.id === selectedWorkObjectTemplateDOM.id,
                    }"
                  >
                  </mat-row>
                </mat-table>
              </div>

              <mat-paginator
                (page)="onPageChange($event)"
                [length]="store.totalElements()"
                [pageSize]="store.filters().pageSize"
              >
              </mat-paginator>
            </div>
            <div class="flex--col flex-1 h-100 template-content">
              <div
                class="selected-work-object-template p--16"
                *ngIf="selectedWorkObjectTemplateDOM"
              >
                <div style="flex-shrink: 0; display: flex; flex-wrap: wrap">
                  <span whFlex="50">
                    <div class="w-h-label">
                      {{ "template.model.name" | translate }}
                    </div>
                    <div
                      class="html-overflow"
                      matTooltip="{{
                        selectedWorkObjectTemplateDOM?.templateName
                      }}"
                    >
                      {{ selectedWorkObjectTemplateDOM?.templateName }}
                    </div>
                  </span>
                  <span whFlex="50">
                    <div class="w-h-label">
                      {{ "template.model.extid" | translate }}
                    </div>
                    <div
                      templateName
                      matTooltip="{{ selectedWorkObjectTemplateDOM?.extId }}"
                    >
                      {{ selectedWorkObjectTemplateDOM?.extId }}
                    </div>
                  </span>
                </div>
                <div class="w-h-label desc-label" style="flex-shrink: 0">
                  {{ "template.model.description" | translate }}
                </div>
                <div style="flex-shrink: 0">
                  <mat-form-field whFlex>
                    <textarea
                      [rows]="4"
                      matInput
                      class="no-resize"
                      [value]="
                        selectedWorkObjectTemplateDOM?.templateDescription
                          ? selectedWorkObjectTemplateDOM.templateDescription
                          : ''
                      "
                      [disabled]="true"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
                <div class="work-orders-area">
                  @if (store.isLoadingWorkOrders()) {
                    <div class="work-orders-overlay">
                      <mat-spinner [diameter]="48"></mat-spinner>
                    </div>
                  }
                  <mat-selection-list
                    #workOrderSelectionList
                    class="work-order-selection-list"
                  >
                    <mat-list-option
                      *ngFor="let workOrderTemplate of store.workOrderTemplates()"
                      [value]="workOrderTemplate.id"
                    >
                      <div
                        class="html-overflow"
                        matTooltip="{{ workOrderTemplate?.title }}"
                      >
                        {{ workOrderTemplate?.title }}
                      </div>
                    </mat-list-option>
                  </mat-selection-list>
                </div>
              </div>
              <div
                *ngIf="!selectedWorkObjectTemplateDOM"
                class="select-template-msg flex--r-c-c h-100"
              >
                <span class="flex--r-c-c">
                  {{
                    "template.ui.use.selecttemplate.helpdescription" | translate
                  }}
                </span>
              </div>
              <div
                class="dialog-action-wrapper flex--r-c-fe gap--12"
                *ngIf="isLocationEnabled"
              >
                <w-h-button
                  [text]="'app.cancel.label' | translate | uppercase"
                  matIcon="close"
                  [disabled]="saving"
                  (clicked)="cancel()"
                />
                <w-h-button
                  [text]="'app.next.label' | translate | uppercase"
                  matIcon="arrow_forward"
                  color="accent"
                  type="flat"
                  [disabled]="
                    !isWorkObjectTemplateSelected ||
                    workOrderSelectionList?._value?.length === 0
                  "
                  (clicked)="stepper.next()"
                />
              </div>
              <w-h-button-group
                align="end"
                style="flex-shrink: 0"
                *ngIf="!isLocationEnabled"
              >
                <w-h-button
                  [text]="'app.cancel.label' | translate | uppercase"
                  matIcon="close"
                  [disabled]="saving"
                  (clicked)="cancel()"
                />
                <w-h-button
                  [text]="'app.save.label' | translate | uppercase"
                  matIcon="save"
                  [isLoading]="saving"
                  color="accent"
                  type="flat"
                  [disabled]="!selectedWorkObjectTemplateDOM || saving"
                  (clicked)="handleSubmit()"
                />
              </w-h-button-group>
            </div>
          </div>
        </mat-step>
        <mat-step [stepControl]="locationFormGroup" *ngIf="isLocationEnabled">
          <ng-template matStepLabel>{{
            "template.ui.use.stepper.2.label" | translate
          }}</ng-template>
          <div
            class="flex--col h-100 gap--8 location-view"
            [ngClass]="{ 'active-step': selectedStep() === 1 }"
          >
            <div class="agm-core-location-form-wrapper flex-1">
              <ng-bee-w-h-agm-core-location-form
                [locationFormGroup]="locationFormGroup"
              >
              </ng-bee-w-h-agm-core-location-form>
            </div>
            <div class="dialog-action-wrapper flex--r-c-fe gap--12 p-t--12">
              <w-h-button
                [text]="'app.cancel.label' | translate | uppercase"
                matIcon="close"
                [disabled]="saving"
                (clicked)="cancel()"
              />
              <w-h-button
                [text]="'app.back.label' | translate | uppercase"
                matIcon="arrow_back"
                [disabled]="saving"
                (clicked)="stepper.previous()"
              />
              <w-h-button
                [text]="'app.save.label' | translate | uppercase"
                matIcon="save"
                color="accent"
                type="flat"
                [isLoading]="saving"
                [disabled]="!isLocationValid || saving"
                (clicked)="handleSubmit()"
              />
            </div>
          </div>
        </mat-step>
      </mat-horizontal-stepper>
    </form>
  </div>
</section>
